<template>
  <div class="common_model_item" :class="size">
    <a
      v-lazy:background-image="item.img + imgRule" :href="item.url" class="model_item_a">
      <h5 v-show="!type" class="model_title">{{ item.title || '' }}</h5>
      <div v-show="!type" class="btn_box ellipsis_one">
        <Button class="model_down_btn colorful_btn">立即下载</Button>
      </div>
      <slot />
    </a>
  </div>
</template>

<script>
import Button from '@shared/components/Button/Button.vue'

import { smallImgRule } from '@/common/resources.js'

export default {
  name: 'ModelItem',

  components: { Button },

  props: {
    item: {
      type: Object,
      required: true
    },

    type: {
      type: String,
      default: ''
    },

    size: {
      type: String,
      default: ''
    },

    imgRule: {
      type: String,
      default: smallImgRule
    }
  }
}
</script>

<style lang="scss" scoped>
.common_model_item { position: relative; display: inline-block; width: 280px; height: 316px; font-size: 0;
  &.middle { width: 180px; height: 200px;
    .model_item_a { width: 168px; height: 187px; }
    &:hover {
      .model_title { font-size: 14px; }
      .model_down_btn { width: 120px; height: 40px; line-height: 40px; }
    }
  }
  &.small { width: 150px; height: 170px;
    .model_item_a { width: 140px; height: 159px; }
    &:hover {
      .model_title { font-size: 12px; }
      .model_down_btn { width: 90px; height: 33px; font-size: 12px; line-height: 32px; }
    }
  }

  .model_item_a { position: absolute; top: 0; right: 0; bottom: 0; left: 0; width: 262px; height: 296px; margin: auto; overflow: hidden; text-decoration: none; vertical-align: middle; background-repeat: no-repeat; background-size: cover; border-radius: 8px; box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.2); }
  &:hover {
    .model_item_a { width: 100%; height: 100%; transition: all 0.1s linear; }
    .model_title { display: block;}
    .btn_box { display: block; }
  }
  .model_title { display: none; height: 16px; padding: 13px 10px 30px 10px; font-size: 16px; font-weight: 400; line-height: 16px; color: #fff; text-align: center; background: linear-gradient(180deg, rgba(0,0,0, 0.6), rgba(0,0,0,0)); }
  .btn_box { position: absolute; bottom: 0px; display: none; width: 100%; padding: 20px 0; text-align: center; background: linear-gradient(0deg, rgba(0,0,0, 0.6), rgba(0,0,0,0)); }
  .model_down_btn { display: inline-block; }
}
</style>
